<template>
    <div class="add-review" :class="classNames">
        <div class="add-review__header" v-if="!formIsOpened && !status">
            <slot></slot>
            <button
                class="btn btn-outline-main btn-block"
                @click.prevent="toggleForm(true)"
            >Добавить отзыв
            </button>
        </div>

        <div class="add-review__content">
            <template v-if="formIsOpened">
                <add-review-form :product="productId" @close="toggleForm(false)" @send="onSend"/>
            </template>

            <template v-if="this.status">
                <add-review-notification :response="this.status" @close="hideNotification"/>
            </template>
        </div>
    </div>
</template>

<script>
import AddReviewForm from './add-review-form';
import AddReviewNotification from './add-review-notification';

export default {
    name: 'add-review',

    data() {
        return {
            formIsOpened: false,
            status: null,
        };
    },

    props: {
        productId: {
            required: true,
            type: Number,
        },

        classModifier: {
            type: String,
        },
    },

    components: {
        AddReviewForm,
        AddReviewNotification,
    },

    methods: {
        toggleForm(flag) {
            this.formIsOpened = flag;

            this.resizeWrapper();
        },

        hideNotification() {
            this.status = null;
            this.resizeWrapper();
        },

        onSend(status) {
            this.status = status;
            this.formIsOpened = false;
            this.resizeWrapper();
        },

        resizeWrapper() {
            setTimeout(() => {
                // $(this.$el).closest('.swiper-wrapper').height($('.add-review').height());
                const wrapper = $(this.$el).closest('.swiper-wrapper');
                const reviewList = wrapper.find('.reviews-list');
                wrapper.height(reviewList.height() + $(this.$el).height());
            }, 0);
        },
    },

    computed: {
        classNames() {
            return {
                'add-review--open': this.formIsOpened,
                [`add-review--${this.classModifier}`]: !!this.classModifier,
            };
        },
    },
};
</script>
